export var Themes = /*#__PURE__*/function (Themes) {
  Themes["Purple"] = "purple";
  Themes["PurpleDark"] = "purpleDark";
  Themes["Green"] = "green";
  Themes["GreenDark"] = "greenDark";
  return Themes;
}({});
export var Brand = /*#__PURE__*/function (Brand) {
  Brand["Cloud"] = "Cloud";
  Brand["CloudDark"] = "CloudDark";
  Brand["MLSpace"] = "MLSpace";
  Brand["MLSpaceDark"] = "MLSpaceDark";
  Brand["Site"] = "Site";
  Brand["SiteDark"] = "SiteDark";
  Brand["Admin"] = "Admin";
  Brand["AdminDark"] = "AdminDark";
  return Brand;
}({});